/**
 * Legacy HistoryApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.historyApi`) keep resolving.
 *
 * The actual HistoryApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/history/history-api.service.ts
 */
angular.module("acme.common.service.historyApi", [
  "acme.common.factory.QueryStringBuilder",
  "acme.common.factory.apiVersion",
]);
